module.exports = __webpack_public_path__ + "img/logo_moneygram3.1b55131f.svg";